module.exports = __webpack_public_path__ + "img/66.faa79bb8.jpg";